import { Add, Delete, Edit, Visibility } from "@mui/icons-material";
import { Button, Grid, IconButton, TablePagination } from "@mui/material";
import { Box } from "@mui/system";
import CustomTable from "components/table";
import { SortFn, TableHeaderItem } from "components/table/TableHeader";
import { useEffect, useMemo, useState } from "react";
import { GRID_SPACING } from "utils/constants";
import { commonTableStyles as styles } from "../../components/table/tableStyles";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PaginationTypes, getRequestedCongregations } from "./action";
import { RootState } from "store";
import { Congregation as CongregationType } from "utils/modals";
import ROUTE_NAMES from "routes/routeNames";

const COLUMNS: TableHeaderItem[] = [
  {
    id: "id",
    label: "Congregation ID",
    canSort: false,
  },
  {
    id: "name",
    label: "Congregation Name",
    canSort: false,
  },
  {
    id: "state",
    label: "Congregation State",
    canSort: false,
  },
  {
    id: "city",
    label: "Congregation City",
    canSort: false,
  },
  {
    id: "zipcode",
    label: "Congregation Zipcode",
    canSort: false,
  },
  // {
  //     id: "Created At",
  //     label: "Created At",
  //     canSort: false,
  // },
  {
    id: "actions",
    label: "Actions",
    canSort: false,
  },
];

const NA = "-";

export default function RequestCongregation() {
  const navigate: any = useNavigate();
  const dispatch: Function = useDispatch();
  const congregationState: CongregationType = useSelector(
    (state: RootState) => state.CongregationReducer.requestCongregation
  );
  const { isLoading } = congregationState;

  const [pagination, setPagination] = useState<PaginationTypes>({
    page: 0,
    limit: 10,
  });

  useEffect(() => {
    dispatch(getRequestedCongregations({}));
  }, []);

  const handleSort: SortFn = (id: string) => {
    console.log(id);
  };
  const dataForTable = useMemo(() => {
    const allData: Record<string, any>[] = [];
    for (let i = 0; i < congregationState.result.length; i++) {
      let data: Record<string, any> = {};
      const currentValue: Record<string, any> = congregationState.result[i];
      for (let j = 0; j < COLUMNS.length; j++) {
        const colId = COLUMNS[j].id;
        switch (colId) {
          case "actions": {
            data[colId] = (
              <Box display={"flex"} gap={1}>
                <IconButton
                  onClick={() => {
                    navigate(
                      ROUTE_NAMES.MAIN_ROUTES.REQUESTED_CONGREGATION_DETAILS,
                      {
                        state: {
                          id: currentValue.id,
                        },
                      }
                    );
                    // navigate(
                    //   ROUTE_NAMES.MAIN_ROUTES.REQUESTED_CONGREGATION_DETAILS,{}
                    // );
                  }}
                  size="small"
                  sx={{
                    ...styles.tableHeader,
                    borderRadius: "4px",
                  }}
                >
                  <Visibility fontSize="small" />
                </IconButton>
              </Box>
            );
            break;
          }
          default: {
            data[colId] = currentValue[colId] || NA;
            break;
          }
        }
      }
      allData.push(data);
    }
    return allData;
  }, [congregationState.result]);

  const handleChangePage = (_: any, newPage: number) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newLimit = parseInt(event.target.value, 10);
    setPagination((prev) => ({
      ...prev,
      limit: newLimit,
    }));
  };

  return (
    <Grid container spacing={GRID_SPACING}>
      <Grid item xs={12} id={"test-id-123"}>
        <Box my={1} display="flex" justifyContent="end">
          <Box my={1} display="flex">
            {congregationState.count > 0 && (
              <TablePagination
                component="div"
                count={congregationState.count}
                page={pagination.page}
                onPageChange={handleChangePage}
                rowsPerPage={pagination.limit}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Box>
        </Box>
        <div>
          <CustomTable
            columns={COLUMNS}
            handleSort={handleSort}
            sortConfig={{
              colId: "1",
              direction: "asc",
            }}
            data={dataForTable}
            isLoading={isLoading}
          />
        </div>
      </Grid>
    </Grid>
  );
}
